import Vue from 'vue';
import * as Tone from 'tone'; // Move Tone.js import before other imports
import App from './App.vue';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

// Ensure AudioContext starts only after a user interaction
document.addEventListener('click', async () => {
  await Tone.start();
}, { once: true });

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
